// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__BgVim","insightsList":"newBusinessInsightsMenu_insightsList__o70CL","active":"newBusinessInsightsMenu_active__1HQ1r"};